export enum PayoutMethod {
  BankTransfer = "BANK_TRANSFER",
  Swish = "SWISH",
}
